import { useEffect, useState } from 'react';
import { DATA_ATTR_EXTENSION_INSTALLED } from '@flow-doc/shared';
const EXTENSION_FLAG_ATTR = DATA_ATTR_EXTENSION_INSTALLED;
const EXTENSION_READY_EVENT = 'cricket-studio-extension-ready';
function readExtensionInstalledFromDom() {
    return document.documentElement.getAttribute(EXTENSION_FLAG_ATTR) === 'installed';
}
/**
 * Tracks whether the browser extension has injected its install marker.
 * Returns `null` while status is being resolved.
 */
export function useExtensionInstalled(enabled = true) {
    const [installed, setInstalled] = useState(enabled ? null : false);
    useEffect(() => {
        if (!enabled) {
            setInstalled(false);
            return;
        }
        let active = true;
        const check = () => {
            if (!active)
                return;
            setInstalled(readExtensionInstalledFromDom());
        };
        const markInstalled = () => {
            if (!active)
                return;
            setInstalled(true);
        };
        // Initial check + short re-check window for late extension injection.
        check();
        const timers = [250, 600, 1200].map((ms) => window.setTimeout(check, ms));
        window.addEventListener(EXTENSION_READY_EVENT, markInstalled);
        return () => {
            active = false;
            timers.forEach((timer) => window.clearTimeout(timer));
            window.removeEventListener(EXTENSION_READY_EVENT, markInstalled);
        };
    }, [enabled]);
    return installed;
}
